module.exports = __webpack_public_path__ + "img/sup_login_5.de546ea0.png";